import { useEffect, useState } from 'react';

import { fetchSuppliersPublic } from '../lib/suppliers';
import { fetchReferencesPublic } from '../lib/references';
import { fetchTeamPublic } from '../lib/team';
import { getFileUrl } from '../lib/pb';


export default function QuiSommesNous() {
  const [team, setTeam] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [teamIndex, setTeamIndex] = useState(0);
  const [teamColumns, setTeamColumns] = useState(1);


  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const [t, s, r] = await Promise.all([
          fetchTeamPublic(),
          fetchSuppliersPublic(),
          fetchReferencesPublic(),
        ]);
        if (!cancelled) {
          setTeam(t || []);
          setSuppliers(s || []);
          setReferences(r || []);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e.message || 'Erreur lors du chargement des partenaires');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    function handleResize() {
      const w = window.innerWidth;
      if (w <= 700) {
        setTeamColumns(1);
      } else if (w <= 1024) {
        setTeamColumns(2);
      } else {
        setTeamColumns(3);
      }
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!team.length) return;
    setTeamIndex(0);
    const id = setInterval(() => {
      setTeamIndex(prev => (prev + (teamColumns || 1)) % team.length);
    }, 6000);
    return () => clearInterval(id);
  }, [team.length, teamColumns]);


  return (
    <>
    <div className="about-page-premium-wrap">
      <div className="container-about-premium">
        
        {/* HEADER SECTION */}
        <header className="about-header-signature">
           <div className="tag-line-premium">AEF 32 • EXCELLENCE & PROXIMITÉ</div>
           <h1>Qui sommes-nous ?</h1>
           <p className="about-subtitle">
             Spécialiste des portails, automatismes et fermetures, 
             au service des particuliers et professionnels en Occitanie.
           </p>
        </header>

        {/* EXPERTISE SECTION */}
        <section className="expertise-signature-row">
           <div className="expertise-main-card shadow-signature">
              <div className="expertise-emerald-bar"></div>
              <h2>Notre expertise</h2>
              <div className="expertise-text-body">
                <p>
                  Forte de plus de <strong>15 ans d'expérience</strong> dans le domaine des automatismes et des portails, 
                  notre société s'est imposée comme un acteur de référence dans le secteur. 
                  Nous mettons un point d'honneur à proposer des solutions innovantes et sur mesure.
                </p>
                <p>
                  Que ce soit pour la vente, l'installation ou la maintenance, nous offrons un accompagnement 
                  complet et personnalisé à chaque étape de votre projet.
                </p>
              </div>
           </div>

           <div className="expertise-visual-cta">
              <div className="logo-premium-box shadow-signature">
                 <img src="/images/logo.jpg" alt="AEF32 Logo Edition" />
                 <div className="badge-experience">15+ ans</div>
              </div>
              <a href="/realisations" className="btn-gold-signature-full">
                 Voir nos réalisations <span className="arrow-icon">→</span>
              </a>
           </div>
        </section>

        {error && <p style={{ color: 'crimson', marginTop: 16, textAlign: 'center' }}>{error}</p>}

        <style>{`
          .about-page-premium-wrap { background: #fff; padding: 40px 0; font-family: 'Inter', sans-serif; }
          .container-about-premium { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
          
          /* HEADER */
          .about-header-signature { text-align: center; margin-bottom: 60px; }
          .tag-line-premium { 
             font-size: 11px; font-weight: 800; color: var(--accent); 
             letter-spacing: 2px; margin-bottom: 15px; 
          }
          .about-header-signature h1 { 
             font-size: clamp(32px, 5vw, 52px); font-weight: 900; 
             color: #0f172a; margin: 0 0 15px 0; letter-spacing: -1.5px;
          }
          .about-subtitle { font-size: 18px; color: #64748b; max-width: 700px; margin: 0 auto; line-height: 1.6; }

          /* EXPERTISE ROW */
          .expertise-signature-row { 
             display: grid; grid-template-columns: 1fr 380px; gap: 40px; 
             margin-bottom: 80px; align-items: center;
          }
          .expertise-main-card { 
             background: #fff; padding: 45px; border-radius: 32px; 
             border: 1px solid #f1f5f9; position: relative;
             box-shadow: 0 20px 50px rgba(15, 23, 42, 0.04);
          }
          .expertise-emerald-bar { 
             position: absolute; left: 0; top: 45px; width: 4px; height: 60px; 
             background: var(--accent); border-radius: 0 4px 4px 0; 
          }
          .expertise-main-card h2 { font-size: 28px; font-weight: 900; color: #0f172a; margin-bottom: 25px; }
          .expertise-text-body p { font-size: 16px; color: #475569; line-height: 1.8; margin-bottom: 15px; }
          .expertise-text-body strong { color: #0f172a; }

          .expertise-visual-cta { display: flex; flex-direction: column; gap: 20px; align-items: center; }
          .logo-premium-box { 
             width: 100%; border-radius: 28px; overflow: hidden; background: #fff; 
             border: 1px solid #f1f5f9; position: relative;
          }
          .logo-premium-box img { width: 100%; height: 260px; object-fit: cover; }
          .badge-experience { 
             position: absolute; top: 15px; right: 15px; background: #0f172a; 
             color: #fff; padding: 8px 15px; border-radius: 12px; font-size: 12px; font-weight: 800; 
          }
          
          .btn-emerald-signature-full {
             width: 100%; background: var(--accent); color: #fff; text-decoration: none;
             padding: 18px; border-radius: 16px; font-weight: 800; text-align: center;
             display: flex; align-items: center; justify-content: center; gap: 10px;
             transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
             box-shadow: 0 10px 25px rgba(34, 197, 94, 0.3);
          }
          .btn-emerald-signature-full:hover { transform: translateY(-5px); background: var(--accent-600); box-shadow: 0 15px 35px rgba(34, 197, 94, 0.4); }
          .arrow-icon { font-size: 20px; font-weight: 400; }

          @media (max-width: 1024px) {
             .expertise-signature-row { grid-template-columns: 1fr; }
             .expertise-visual-cta { order: -1; }
          }
        `}</style>

        {!!team.length && !error && (
          <section className="team-section-signature" style={{ marginTop: 60, marginBottom: 60 }}>
            <div style={{ textAlign: 'center', marginBottom: 40 }}>
              <div className="tag-premium-mini">L'EXCELLENCE AEF32</div>
              <h2 style={{ fontSize: 32, fontWeight: 900, color: '#0f172a', margin: '10px 0' }}>Notre équipe</h2>
              <p style={{ margin: 0, fontSize: 16, color: '#64748b' }}>
                Des professionnels passionnés, au service de vos projets.
              </p>
            </div>

            <div className="team-carousel-container">
              <button
                className="carousel-nav-btn prev"
                onClick={() => {
                  if (!team.length) return;
                  setTeamIndex(prev => (prev - 1 + team.length) % team.length);
                }}
              >
                ‹
              </button>
              <button
                className="carousel-nav-btn next"
                onClick={() => {
                  if (!team.length) return;
                  setTeamIndex(prev => (prev + 1) % team.length);
                }}
              >
                ›
              </button>

              <div className="team-grid-signature">
                {Array.from({ length: Math.min(teamColumns, team.length) }, (_, i) => {
                  const idx = (teamIndex + i) % team.length;
                  const m = team[idx];
                  return (
                    <article key={m.id} className="team-card-premium shadow-signature">
                      <div className="card-visual">
                         <div className="visual-bg"></div>
                         {m.photo ? (
                           <img src={getFileUrl(m, m.photo)} alt={m.name} />
                         ) : (
                           <div className="avatar-dummy">👤</div>
                         )}
                         <div className="role-badge">{m.role || 'Expert'}</div>
                      </div>
                      <div className="card-content">
                        <h3>{m.name}</h3>
                        <div className="bio-scroll">
                          {m.bio || "Membre dévoué de l'équipe AEF32."}
                        </div>
                      </div>
                    </article>
                  );
                })}
              </div>
            </div>

            <div className="carousel-dots-signature">
              {team.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setTeamIndex(idx)}
                  className={`dot-item ${idx === teamIndex ? 'active' : ''}`}
                />
              ))}
            </div>

            <style>{`
              .team-section-signature { font-family: 'Inter', sans-serif; }
              .tag-premium-mini { 
                font-size: 10px; font-weight: 800; color: var(--accent); 
                letter-spacing: 2px; text-transform: uppercase; 
              }
              .team-carousel-container { position: relative; padding: 0 50px; }
              .team-grid-signature { 
                 display: grid; gap: 24px; 
                 grid-template-columns: repeat(${Math.min(teamColumns, team.length || 1)}, minmax(0, 1fr));
              }
              .team-card-premium { 
                background: #fff; border-radius: 24px; border: 1px solid #f1f5f9; 
                overflow: hidden; transition: transform 0.3s ease; height: 100%;
                box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
              }
              .team-card-premium:hover { transform: translateY(-5px); }
              .card-visual { height: 280px; position: relative; background: #f8fafc; overflow: hidden; }
              .visual-bg { position: absolute; inset: 0; background: linear-gradient(135deg, rgba(34, 197, 94, 0.05), transparent); }
              .card-visual img { width: 100%; height: 100%; object-fit: cover; object-position: top center; }
              .avatar-dummy { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 40px; opacity: 0.2; }
              .role-badge { 
                position: absolute; bottom: 12px; left: 12px; background: rgba(255,255,255,0.9); 
                backdrop-filter: blur(8px); padding: 5px 12px; border-radius: 8px; 
                font-size: 11px; font-weight: 800; color: var(--accent); text-transform: uppercase;
                box-shadow: 0 4px 10px rgba(0,0,0,0.1);
              }
              .card-content { padding: 24px; }
              .card-content h3 { margin: 0 0 10px 0; font-size: 20px; font-weight: 900; color: #0f172a; }
              .bio-scroll { 
                font-size: 14px; color: #64748b; line-height: 1.6; 
                display: -webkit-box; -webkit-line-clamp: 5; -webkit-box-orient: vertical; overflow: hidden;
              }
              .carousel-nav-btn {
                position: absolute; top: 50%; transform: translateY(-50%); 
                width: 40px; height: 40px; border-radius: 50%; border: 1px solid #e2e8f0;
                background: #fff; color: #0f172a; font-size: 24px; cursor: pointer;
                display: flex; align-items: center; justify-content: center; z-index: 5;
                transition: all 0.2s; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
              }
              .carousel-nav-btn:hover { background: #0f172a; color: #fff; border-color: #0f172a; }
              .carousel-nav-btn.prev { left: 0; }
              .carousel-nav-btn.next { right: 0; }
              .carousel-dots-signature { display: flex; justify-content: center; gap: 8px; margin-top: 30px; }
              .dot-item { 
                width: 8px; height: 8px; border-radius: 50%; background: #e2e8f0; 
                border: none; cursor: pointer; transition: all 0.3s; padding: 0;
              }
              .dot-item.active { width: 24px; background: var(--accent); border-radius: 4px; }
              @media (max-width: 640px) {
                .team-carousel-container { padding: 0 40px; }
                .card-visual { height: 200px; }
              }
            `}</style>
          </section>
        )}

        {(!!suppliers.length || !!references.length) && !error && (
          <div className="partners-and-proximity-wrap">
            
            {/* 4. SUPPLIERS */}
            {!!suppliers.length && (
              <section className="suppliers-section-signature">
                <div className="section-header-centered">
                  <div className="tag-premium-mini">PARTENAIRES TECHNIQUES</div>
                  <h2>Nos fournisseurs</h2>
                  <p>Le meilleur de la technologie sélectionné pour la fiabilité de vos installations.</p>
                </div>
                <div className="suppliers-pills-row">
                  {suppliers.map(s => {
                    const img = s.logo ? (
                      <img src={getFileUrl(s, s.logo)} alt={s.name} />
                    ) : (
                      <span className="supplier-lbl">{s.name}</span>
                    );
                    return (
                      <div key={s.id} className="supplier-pill shadow-signature">
                        {s.website ? (
                          <a href={s.website} target="_blank" rel="noreferrer">{img}</a>
                        ) : (
                          <div className="img-wrap">{img}</div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </section>
            )}

            {/* 5. PROXIMITY CARD */}
            <section className="proximity-section-signature">
              <div className="proximity-card-elite shadow-signature">
                 <div className="proximity-content-grid">
                    <div className="proximity-text">
                       <h2 className="title-with-accent">Une entreprise de proximité</h2>
                       <p className="p-major">
                          Basés dans le <strong>Gers</strong> et intervenant sur toute l'<strong>Occitanie</strong>, 
                          nous privilégions une relation de confiance et de long terme. 
                       </p>
                       <p className="p-minor">
                         Forts de nombreuses années d'expérience terrain, nous sommes votre interlocuteur unique, 
                         de l'étude initiale à la maintenance de vos équipements.
                       </p>
                       <div className="proximity-badges-row">
                          <div className="p-badge"><div className="p-dot"></div> Fiabilité</div>
                          <div className="p-badge"><div className="p-dot"></div> Sécurité</div>
                          <div className="p-badge"><div className="p-dot"></div> Durabilité</div>
                       </div>
                    </div>
                    <div className="proximity-icon-box">
                       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="map-icon-luxury"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                    </div>
                 </div>
              </div>
            </section>

            {/* 6. REFERENCES (Ils nous font confiance) */}
            {!!references.length && (
              <section className="references-section-signature">
                <div className="section-header-centered">
                  <div className="tag-premium-mini">CONFIANCE & RÉFÉRENCES</div>
                  <h2>Ils nous font confiance</h2>
                  <p>Particuliers, entreprises et collectivités qui ont choisi l'Excellence AEF32.</p>
                </div>
                <div className="references-grid-elite">
                  {references.map(ref => (
                    <div key={ref.id} className="ref-card-studio shadow-signature">
                      {ref.logo && (
                        <div className="ref-logo-wrap">
                          <img src={getFileUrl(ref, ref.logo)} alt={ref.name} />
                        </div>
                      )}
                      <div className="ref-body-info">
                        <h4>{ref.name}</h4>
                        {ref.description && <p className="ref-desc-txt">{ref.description}</p>}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

          </div>
        )}

        <style>{`
          /* COMPLEMENTARY SIGNATURE STYLES */
          .section-header-centered { text-align: center; margin-bottom: 40px; }
          .section-header-centered h2 { font-size: 30px; font-weight: 900; color: #0f172a; margin: 10px 0; }
          .section-header-centered p { font-size: 15px; color: #64748b; max-width: 600px; margin: 0 auto; }

          /* SUPPLIERS */
          .suppliers-section-signature { margin-bottom: 80px; padding: 40px 0; }
          .suppliers-pills-row { display: flex; flex-wrap: wrap; gap: 15px; justify-content: center; }
          .supplier-pill { 
             background: #fff; border-radius: 999px; border: 1px solid #f1f5f9; padding: 12px 25px;
             display: flex; align-items: center; justify-content: center; transition: all 0.3s;
             box-shadow: 0 4px 10px rgba(0,0,0,0.02); min-height: 54px;
          }
          .supplier-pill img { max-height: 28px; max-width: 90px; object-fit: contain; filter: grayscale(1); opacity: 0.7; transition: all 0.3s; }
          .supplier-pill:hover { border-color: var(--accent); transform: translateY(-3px); box-shadow: 0 10px 20px rgba(34, 197, 94, 0.1); }
          .supplier-pill:hover img { filter: grayscale(0); opacity: 1; }
          .supplier-lbl { font-size: 13px; font-weight: 800; color: #475569; letter-spacing: 0.5px; }

          /* PROXIMITY CARD ELITE */
          .proximity-section-signature { margin-bottom: 80px; }
          .proximity-card-elite { 
             background: #f0fdf4; border-radius: 36px; border: 1px solid #f1f5f9; padding: 60px;
             position: relative; overflow: hidden;
          }
          .proximity-content-grid { display: grid; grid-template-columns: 1fr 200px; gap: 40px; align-items: center; }
          .title-with-accent { font-size: 28px; font-weight: 900; color: #0f172a; margin-bottom: 25px; position: relative; }
          .title-with-accent::after { content: ''; position: absolute; left: 0; bottom: -10px; width: 40px; height: 3px; background: var(--accent); }
          .p-major { font-size: 18px; color: #0f172a; line-height: 1.6; margin-bottom: 20px; }
          .p-minor { font-size: 15px; color: #64748b; line-height: 1.7; margin-bottom: 30px; }
          .proximity-badges-row { display: flex; gap: 20px; flex-wrap: wrap; }
          .p-badge { 
             background: #fff; border: 1px solid #e2e8f0; padding: 6px 14px; border-radius: 10px;
             font-size: 12px; font-weight: 800; color: var(--accent); text-transform: uppercase; letter-spacing: 0.5px;
             display: flex; align-items: center; gap: 8px;
          }
          .p-dot { width: 5px; height: 5px; border-radius: 50%; background: var(--accent); }
          .proximity-icon-box { display: flex; justify-content: center; }
          .map-icon-luxury { width: 100px; height: 100px; color: var(--accent); opacity: 0.1; }

          /* REFERENCES GRID */
          .references-section-signature { padding-bottom: 40px; }
          .references-grid-elite { display: flex; flex-wrap: wrap; gap: 24px; justify-content: center; }
          .ref-card-studio { 
             background: #fff; border-radius: 24px; border: 1px solid #f1f5f9; padding: 25px;
             display: flex; flex-direction: column; align-items: center; text-align: center;
             transition: all 0.3s ease; width: 280px; 
          }
          .ref-card-studio:hover { transform: translateY(-5px); border-color: var(--accent); box-shadow: 0 15px 30px rgba(0,0,0,0.04); }
          .ref-logo-wrap { height: 60px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px; width: 100%; }
          .ref-logo-wrap img { max-height: 35px; max-width: 140px; object-fit: contain; }
          .ref-body-info h4 { font-size: 15px; font-weight: 900; color: #0f172a; margin: 0 0 8px 0; }
          .ref-desc-txt { font-size: 13px; color: #64748b; line-height: 1.4; }

          @media (max-width: 768px) {
             .proximity-card-elite { padding: 40px 30px; }
             .proximity-content-grid { grid-template-columns: 1fr; }
             .proximity-icon-box { display: none; }
             .references-grid-elite { grid-template-columns: 1fr 1fr; }
          }
          @media (max-width: 480px) {
             .references-grid-elite { grid-template-columns: 1fr; }
          }
        `}</style>
      </div>
    </div>
    </>
  );
}
